import { Checkbox } from "primereact/checkbox";

const RandomizeAOBlock = ({
  randomizeAnsOpt,
  updateRandomizeAnsOpt,
  isLocked,
}) => {
  return (
    <div className="d-flex">
      <div className="randomize-block d-flex align-items-center py-2 px-3">
        <div className="me-2 randomize-ans-opt-text">
          Randomize answer options:
        </div>
        <Checkbox
          inputId={`all-input`}
          className="ms-2"
          value={0}
          onChange={(e) =>
            e.target.checked
              ? updateRandomizeAnsOpt(e.target.value)
              : updateRandomizeAnsOpt(null)
          }
          checked={randomizeAnsOpt === 0}
          disabled={isLocked}
        />
        <label htmlFor={`all-input`} className="ms-2">
          <span className="me-1">All</span>
        </label>
        <Checkbox
          inputId={`except-last-input`}
          className="ms-2"
          value={1}
          onChange={(e) =>
            e.target.checked
              ? updateRandomizeAnsOpt(e.target.value)
              : updateRandomizeAnsOpt(null)
          }
          checked={randomizeAnsOpt === 1}
          disabled={isLocked}
        />
        <label htmlFor={`except-last-input`} className="ms-2">
          <span className="me-1">All except last</span>
        </label>
        <Checkbox
          inputId={`last-2-2`}
          className="ms-2"
          value={2}
          onChange={(e) =>
            e.target.checked
              ? updateRandomizeAnsOpt(e.target.value)
              : updateRandomizeAnsOpt(null)
          }
          checked={randomizeAnsOpt === 2}
          disabled={isLocked}
        />
        <label htmlFor={`last-2-input`} className="ms-2">
          <span className="me-1">All except last 2</span>
        </label>
      </div>
    </div>
  );
};

export default RandomizeAOBlock;
